import { useAppSelector } from "../../store";
import { userRole } from "../../store/slices/user";
import { RolesType } from "../../types/user";
import PatientDashboard from "../../components/PatientDashboard";
import DoctorDashboard from "../../components/DoctorDashboard";

const Home = () => {
  const role = useAppSelector(userRole) as NonNullable<RolesType>;

  return (
    role === "patient" ? <PatientDashboard/> : <DoctorDashboard/>
  );
};

export default Home;
